export default {
  backLabel: {
    id: 'insurance_policy_details_back_label',
    defaultMessage: 'All Protection Plans',
  },
  submitClaimSectionTitle: {
    id: 'insurance_policy_details_submit_claim_section_title',
    defaultMessage: 'Issue with your device?',
  },
  helpSectionTitle: {
    id: 'insurance_policy_details_help_section_title',
    defaultMessage: 'How else can we help?',
  },
  updatePaymentMethodSuccessToastTitle: {
    id: 'insurance_policy_details_update_payment_method_success_toast_title',
    defaultMessage: 'Your payment method is up to date.',
  },
}
